import { PortalApiError, emitPortalTelemetry } from "./portalApi";

function coarseMessage(value: unknown): string {
  if (value instanceof Error && value.name) return value.name;
  if (typeof value === "string" && value.trim()) return value.trim().slice(0, 80);
  return "unknown";
}

export function installClientTelemetry(): void {
  if (typeof window === "undefined") return;

  window.addEventListener("error", (event) => {
    emitPortalTelemetry({
      routeTemplate: "/api/client-runtime",
      errorCode: "frontend_runtime_error",
      retryable: false,
      reachability: "unknown",
      requestId: coarseMessage(event.error || event.message)
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (event.reason instanceof PortalApiError) return;
    emitPortalTelemetry({
      routeTemplate: "/api/client-runtime",
      errorCode: "frontend_unhandled_rejection",
      retryable: false,
      reachability: "unknown",
      requestId: coarseMessage(event.reason)
    });
  });
}
